import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';
import Header from '../../../components/Header';
import Barra from '../../../components/barra';
import imagen from '../../../imagenes/licor.png';
import MenuLicores from '../../../components/hacienda/impuestoLicores/menuLicores';
import TablaContribuyenteLicores from '../../../components/hacienda/impuestoLicores/tablaContribuyentesLicores';
import Footer from '../../../components/Footer';
import MenuPrincipalLicores from '../../../components/hacienda/impuestoLicores/menuPrincipalLicores';

function ContribuyentesLicores() {

  let op = require('../../../../src/modulos/datos');
  const { user } = useContext(AuthContext);
  let per = JSON.parse(localStorage.getItem('permisos'));

  return (

    user && (
      <div style={{ height: "100vh", padding: 0 }}>
          
        <div  className="col-md-12" style={{ height: "95%", padding: 0 }}>
           <MenuPrincipalLicores/>
        </div>
         
        <div  className="col-md-12" style={{ height: "5%", padding: 0 }}>
           <Footer />
        </div>
      </div>

    )


  );
}


export default ContribuyentesLicores;
